import { useTranslation } from 'next-i18next'

import { Link } from '~/components/Link'

import { IconName } from '~/components/Icons'
import ArrowLeftBoldIcon from '~/components/Icons/svgs/ArrowLeftBoldIcon'
import InfoIIcon from '~/components/Icons/svgs/InfoIIcon'
import TimesIcon from '~/components/Icons/svgs/TimesIcon'
import SVGIcon from '~/components/Icons/svgs/SVGIcon'
import curriculumAnalytics from '~/analytics/curriculum/curriculumAnalytics'
import bootcampAnalytics from '~/analytics/bootcamp/bootcampAnalytics'

import useIsBootcampGradePage from '../hooks/useIsBootcampGradePage'

interface Props {
  iconName: IconName
  iconColor?: string // Tailwind text class e.g. text-red
  link?: string
  onClick?: () => void
  className?: string
  iconSize?: number
  ariaLabel?: string
}

const getIconComponent = (name: string): ((props: { [key: string]: any }) => React.ReactElement) => {
  switch (name) {
    case 'arrow-left-bold':
      return ArrowLeftBoldIcon
    case 'info-i':
      return InfoIIcon
    case 'times':
      return TimesIcon
    default:
      return TimesIcon
  }
}

const CircleIconButton = ({
  iconName,
  iconColor = 'text-blue-blueberry',
  link,
  onClick,
  className = 'w-10 h-10 md:w-12 md:h-12 bg-white',
  iconSize = 28,
  ariaLabel,
}: Props): React.ReactElement => {
  const wrapperClass = `rounded-full flex justify-center items-center relative ${className}`
  const { t } = useTranslation('generics')
  const showGradeQuery = useIsBootcampGradePage()
  const icon = (
    <span className="pointer-events-none">
      <SVGIcon icon={getIconComponent(iconName)} pathClassName={iconColor} size={iconSize} />
    </span>
  )

  if (link) {
    return (
      <Link
        aria-label={t('ariaLabelButtons.backToBootcamp')}
        className={wrapperClass}
        onClick={() =>
          showGradeQuery
            ? curriculumAnalytics.logButtonClick('back_button')
            : bootcampAnalytics.logButtonClick('back_button')
        }
        to={link}
      >
        {icon}
      </Link>
    )
  }

  return (
    <button aria-label={ariaLabel} className={wrapperClass} onClick={onClick}>
      {icon}
    </button>
  )
}

export default CircleIconButton
